import {Component} from "preact";
import styles from './styles.scss';

export default class LetterIcon extends Component {

    colors = [
        '#F44336',
        '#E91E63',
        '#9C27B0',
        '#673AB7',
        '#3F51B5',
        '#2196F3',
        '#03A9F4',
        '#00BCD4',
        '#009688',
        '#4CAF50',
        '#8BC34A',
        '#C0CA33',
        '#FFB300',
        '#FB8C00',
        '#FF5722',
    ];


    render({text}, state, context) {
        const stringText = text || ' ';
        const letter = stringText[0];

        let index = 0;
        stringText.split('').forEach((c, i) => {
            index += stringText.charCodeAt(i);
        });
        index = (index + stringText.length) % this.colors.length;

        return (
            <div class={styles.icon} style={{backgroundColor: this.colors[index]}}>{letter}</div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/common/letter-icon/index.js